<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{
              name: 'DashboardHome',
            }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'SystemSettingsHome',
              }"
            >全系統管理</b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'SystemSuiteList',
              }"
            >系統方案管理</b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'SystemSuitePackageList',
                params: {
                  suiteId: suiteId,
                },
              }"
            >{{getPageTitle()}}</b-breadcrumb-item>
            <b-breadcrumb-item active>
              {{ title }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center justify-content-between">
          <h4 class="font-weight-bold">{{ title }}</h4>
        </div>
      </div>

      <b-overlay :show="isLoading" rounded opacity="0.6" spinner-small spinner-variant="primary">
        <section class="row mb-8">
          <div class="col-12 col-xl-8">
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="type"
              label-for="type"
            >
              <b-form-input
                id="type"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="state.form.type"
                :state="v$.form.type.$error ? false : null"
                :disabled="isShow"
              ></b-form-input>
              <b-form-invalid-feedback :state="!v$.form.type.$error">此欄位為必填</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="key"
              label-for="key"
            >
              <b-form-input
                id="key"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="state.form.key"
                :state="v$.form.key.$error ? false : null"
                :disabled="isShow"
              ></b-form-input>
              <b-form-invalid-feedback :state="!v$.form.key.$error">此欄位為必填</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="target"
              label-for="target"
            >
              <b-form-input
                id="target"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="state.form.target"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="table"
              label-for="table"
            >
              <b-form-input
                id="table"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                v-model="state.form.table"
                :disabled="isShow"
              ></b-form-input>
            </b-form-group>
          </div>
        </section>
      </b-overlay>

      <div class="d-flex justify-content-center">
        <b-button class="mr-4" variant="outline-danger" @click="handleCancel">{{ isShow ? '返回' : '取消' }}</b-button>
        <b-overlay
          v-if="!isShow"
          :show="isSubmitting"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button variant="success" @click="handleSubmit">
            {{
              isEdit ? "確認修改" : "確認新增"
            }}
          </b-button>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import { reactive } from "@vue/composition-api";
import { mapState, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import suiteApi from "../../../apis/suite";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";

export default {
  setup() {
    const state = reactive({
      form: {
        type: "",
        key: "",
        target: "",
        table: "",
      },
    });
    const rules = {
      form: {
        type: { required },
        key: { required },
      },
    };

    const v$ = useVuelidate(rules, state);

    return { state, v$ };
  },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      form: {
        type: "",
        key: "",
        target: "",
        table: "",
      },
      suiteName: null,
    };
  },
  validations() {
    return {
      form: {
        type: { required },
        key: { required },
        target: { required },
        table: { required },
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    suiteId() {
      return this.$route.params.suiteId;
    },
    suitePackageId() {
      return this.$route.params.suitePackageId;
    },
    isEdit() {
      return this.$route.name === "SuitePackageEdit";
    },
    isShow() {
      return this.$route.name === "SuitePackageShow";
    },
    title() {
      switch (true) {
        case this.isEdit:
          return '方案套件編輯';
        case this.isShow:
          return '檢視方案套件';
        default:
          return '新增方案套件';
      }
    },
  },
  mounted() {
    if (this.suitePackageId && !this.checkPermission([consts.SUITE_PACKAGE_LIST_VIEW])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33"
        })
        .then(() => {
          this.$router.push({
            name: "SystemSuitePackageList",
            params: { suiteId: this.suiteId },
            query: this.routeQuery
          });
        });
    } else if (this.suitePackageId) {
      this.fetchSuitePackage();
    } else {
      this.fetchSuite();
    }
  },
  methods: {
    async fetchSuitePackage() {
      try {
        this.isLoading = true;
        const { data } = await suiteApi.getSuitePackageById(this.suiteId, this.suitePackageId);
        const { id, type, key, target, table, created_at, updated_at } = data.data;

        if (this.isShow || this.isEdit) {
          this.form = {
            ...this.form,
          };
          this.state.form = {
            id,
            type,
            key,
            target,
            table,
            created_at,
            updated_at
          };
          this.suiteName = data.suite_name;
        }
      } catch (error) {
        console.log(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        this.handleCancel();
      }
      this.isLoading = false;
    },
    async fetchSuite() {
      try {
        this.isLoading = true;
        const { data } = await suiteApi.getSuiteById(this.suiteId);

        this.suiteName = data.data.name;
      } catch (error) {
        console.log(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        this.handleCancel();
      }
      this.isLoading = false;
    },
    async handleSubmit() {
      const result = await this.v$.$validate();
      if (!result) return;

      if (this.isEdit && !this.checkPermission([consts.SUITE_PACKAGE_MODIFY])) {
        this.$swal.fire({
          type: "error",
          text: "你沒有權限修改此資料",
          confirmButtonColor: "#d33"
        });
        return;
      }

      if (!this.isEdit && !this.checkPermission([consts.SUITE_PACKAGE_CREATE])) {
        this.$swal.fire({
          type: "error",
          text: "你沒有權限新增此資料",
          confirmButtonColor: "#d33"
        });
        return;
      }

      if (this.isEdit) {
        this.handleUpdate();
      } else {
        this.handleCreate();
      }
    },
    async handleUpdate() {
      try {
        this.isSubmitting = true;
        await suiteApi.updateSuitePackage(this.suiteId, this.suitePackageId, {
          ...this.form,
          ...this.state.form,
        });
        this.showSuccessPopup("修改成功");
      } catch (error) {
        this.showErrorMessage(error);
      }
      this.isSubmitting = false;
    },
    async handleCreate() {
      try {
        this.isSubmitting = true;
        console.log(this.suiteId);
        await suiteApi.createSuitePackage(this.suiteId, {
          ...this.form,
          ...this.state.form,
        });
        this.showSuccessPopup("新增成功");
      } catch (error) {
        this.showErrorMessage(error);
      }
      this.isSubmitting = false;
    },
    handleCancel() {
      this.$router.push({
        name: "SystemSuitePackageList",
        params: { suiteId: this.suiteId },
        query: this.routeQuery
      });
    },
    showSuccessPopup(message) {
      this.$swal
        .fire({
          type: "success",
          text: message,
        })
        .then(() => {
          this.$router.push({
            name: "SystemSuitePackageList",
            params: { suiteId: this.suiteId },
            query: this.routeQuery
          });
        });
    },
    showErrorMessage(error) {
      const { status, data } = error.response;

      if (status && status === 422 && data.message) {
        const html = Object.values(data.message)
          .map((m) => m[0])
          .join("<br/>");
        this.$swal.fire({
          type: "error",
          html,
        });
      }
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    getPageTitle() {
      return this.suiteName ? `${this.suiteName} - 方案套件列表` : '方案套件列表';
    }
  },
};
</script>
